import { Text as TextComponent } from "components/ui";
import React, { ComponentProps } from "react";
import { useIsMobile } from "utils/hooks/useIsMobile";

interface PageTextProps {
	text: string;
	fontSize: number;
	textAlign?: string;
	fontWeight?: "normal" | "bold";
	color?: string;
	sx?: any;
	flex?: number;
}

export const PageText = ({ text, fontSize, textAlign, fontWeight, color, sx, ...props }: ComponentProps<typeof TextComponent> & PageTextProps) => {
	const isMobile = useIsMobile();
	let adjustedFontSize = fontSize;
	if (isMobile) {
		switch (fontSize) {
			case 60:
				adjustedFontSize = 28;
				break;
			case 44:
				adjustedFontSize = 24;
				break;
			case 36:
				adjustedFontSize = 22;
				break;
			case 28:
				adjustedFontSize = 20;
				break;
			case 20:
				adjustedFontSize = 18;
				break;
			case 18:
				adjustedFontSize = 16;
				break;
			case 16:
				adjustedFontSize = 14;
				break;
			case 14:
				adjustedFontSize = 13;
				break;
			default:
				adjustedFontSize = fontSize; // Use the original size if no match
				break;
		}
	}

	// Calculate line height based on font size
	const lineHeightMultiplier = adjustedFontSize <= 28 ? 1.6 : 1.2;
	const lineHeight = Math.round(adjustedFontSize * lineHeightMultiplier);

	return (
		<TextComponent {...props} flex={props.flex} sx={sx} style={{ color, textAlign, fontSize: adjustedFontSize, lineHeight, marginBottom: isMobile ? 12 : 20, fontFamily: fontWeight === "bold" ? "Roboto_700Bold" : "" }}>
			{text}
		</TextComponent>
	);
};
